import React from 'react';
import { Loader, Dialog } from 'cdk-radial';
import "./loadingOverlaySpinner.scss";

export default function LoadingOverlaySpinner({ active, text }) {
  return (
    <div>
      <Dialog isOpen={active} id="loading-overlay-id" hideCloseButton hideHeader>
        <div className="plan-terms-dialog-body-container loader">
          <Loader
            open={active}
            style={{ paddingTop: '20px', stroke: '#006cfa' }}
          />
        </div>
        <div className="plan-terms-dialog-header">{text}</div>
      </Dialog>
    </div>
  );
}
